import { render, staticRenderFns } from "./storageRecordList.vue?vue&type=template&id=68fd3e5b&scoped=true&"
import script from "./storageRecordList.vue?vue&type=script&lang=js&"
export * from "./storageRecordList.vue?vue&type=script&lang=js&"
import style0 from "./storageRecordList.vue?vue&type=style&index=0&id=68fd3e5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd3e5b",
  null
  
)

export default component.exports